package uk.co.nickthecoder.kyd.util

import org.khronos.webgl.WebGLRenderingContext.Companion.COLOR_ATTACHMENT0
import org.khronos.webgl.WebGLRenderingContext.Companion.COLOR_BUFFER_BIT
import org.khronos.webgl.WebGLRenderingContext.Companion.FRAMEBUFFER
import org.khronos.webgl.WebGLRenderingContext.Companion.ONE
import org.khronos.webgl.WebGLRenderingContext.Companion.TEXTURE_2D
import org.khronos.webgl.WebGLRenderingContext.Companion.ZERO
import uk.co.nickthecoder.glok.application.GlokTimer
import uk.co.nickthecoder.glok.backend.Texture
import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.backend.webgl.WebGLBackend
import uk.co.nickthecoder.glok.backend.webgl.WebGLTextureWrapper
import uk.co.nickthecoder.glok.util.log

actual fun dumpStack() {
}

actual fun copyTexture(
    src: Texture, srcX: Int, srcY: Int, width: Int, height: Int,
    dest: Texture
) {
    val dest2 = dest as? WebGLTextureWrapper
    val src2 = src as? WebGLTextureWrapper
    if (dest2 == null || src2 == null) {
        log.error("copyTexture failed to cast to WebGLTextureWrapper")
        return
    }

    // If the src texture isn't loaded, then try again (and again) in 1 second.
    if (! src2.isLoaded) {
        log.error("Attempted to copy a texture before it is loaded.")
        // Despite being an error, let's try our best anyway...
        GlokTimer(1.0) {
            copyTexture(src, srcX, srcY, width, height, dest)
        }.start()
        return
    }

    with(WebGLBackend.gl) {

        val frameBufferID = createFramebuffer()
        bindFramebuffer(FRAMEBUFFER, frameBufferID)
        framebufferTexture2D(FRAMEBUFFER, COLOR_ATTACHMENT0, TEXTURE_2D, dest2.texture !!, 0)

        colorMask(true, true, true, true)
        viewport(0, 0, dest.width, dest.height)

        val w = src.width.toFloat()
        val h = src.height.toFloat()
        PlainTextureProgram.blit(
            - 1f, 1f, 1f, - 1f,
            src2.texture !!,
            srcX / w, srcY / h, (srcX + width) / w, (srcY + height) / h
        )

        bindFramebuffer(FRAMEBUFFER, null)
        bindTexture(TEXTURE_2D, null)
        deleteFramebuffer(frameBufferID)
        backend.reportError()

    }
}

actual fun createScreenshot(filename: String, renderWidth: Int) {
    // Does nothing.
}

actual fun createThumbnail(filename: String, thumbnailWidth: Int) {
}
